import React, { useCallback } from 'react';
import { IEditorProps } from '../Editor';
import { EditorEntityPicker } from './EditorEntityPicker';
import { getEntityByID } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Folder/FolderService';
import { ChartDataSource } from '@decisions/server/Silverdark/Components/Page/Charts/ChartDataSource';

/**
 * A Chart Source Picker editor, which launches a picker dialog for groups.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ChartSourcePickerEditor({ child, path, onChange }: IEditorProps) {
  const getEntityLabel = useCallback(async (value: string | object): Promise<string> => {
    const entityHeader = await getEntityByID({ entityID: (value as ChartDataSource)?.ReportId || '' });
    return entityHeader?.EntityName || '';
  }, []);

  return <EditorEntityPicker {...{ child, path, onChange, getEntityLabel, canEdit: false }} />;
}
